import dayjs from 'dayjs';

export const isNextDay = (departureDate: string, arrivalDate: string) =>
  dayjs(arrivalDate).isAfter(departureDate);
